import React, { useState, useEffect } from "react";
import "./VendorPayment.css";
import { useNavigate } from "react-router-dom";
import { db, auth } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

export default function VendorPayment() {
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });
    return () => unsub();
  }, []);

  const handlePayment = async () => {
    try {
      setLoading(true);

      await new Promise((res) => setTimeout(res, 1500));

      if (!currentUser) {
        alert("User not logged in");
        setLoading(false);
        return;
      }

      await setDoc(doc(db, "vendors", currentUser.uid), {
        paymentStatus: "submitted",
        approvalStatus: "pending"
      }, { merge: true });

      navigate("/waiting-approval");
    } catch (error) {
      console.error(error);
      alert("Something went wrong, try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-container">
      <div className="payment-card">
        <h1 className="brand">Connect</h1>
        <h2 className="title">Vendor Activation</h2>

        <div className="price-box">
          <span className="currency">₹</span>
          <span className="amount">99</span>
        </div>

        <p className="desc">
          One-time secure payment to activate your vendor account and unlock all premium features.
        </p>

        <div className="features">
          <p>✔ Verified Vendor Badge</p>
          <p>✔ ID Card Generation</p>
          <p>✔ Dashboard Access</p>
        </div>

        <button
          className="pay-btn"
          onClick={handlePayment}
          disabled={loading}
        >
          {loading ? "Processing..." : "Pay Securely"}
        </button>

        <p className="secure">🔒 100% Secure Payment</p>
      </div>
    </div>
  );
}
